import { personalizedSlipSchema } from "@redotech/redo-model/personalized-slip/personalized-slip-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getPersonalizedSlipTemplatesByTeam = {
  name: "getPersonalizedSlipTemplatesByTeam" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.array(personalizedSlipSchema),
};
